import { render } from "./ToasterComponent.vue?vue&type=template&id=48d3cce8"
import script from "./ToasterComponent.vue?vue&type=script&lang=js"
export * from "./ToasterComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__